import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Typography } from '@mui/material'

const stylesSx = { mt: 0.5, display: 'block'}

// No default button styling here on purpose. This used to pass a `styles` prop
// holding a 25px radius, which is not a React prop name - MUI forwarded it to the
// DOM, so it never applied and only produced an unknown-attribute warning. Each
// caller owns its own CTA appearance (the HubSpot form does it through the
// --global-cta-* tokens), so the dead object is gone rather than corrected into
// `sx`, which would have restyled every other form using this component.
export default function SubmitButtonWithStatus({
  ButtonComponent = Button,
  label = 'Submit',
  loadingLabel = 'Submitting…',
  disabled = false,
  disabledReason = '',
  loading = false,
  buttonProps = {},
}) {
  const isDisabled = disabled || loading
  return (
    <Box>
      <ButtonComponent
        {...buttonProps}
        disabled={isDisabled}
        aria-disabled={isDisabled}
        aria-busy={loading ? true : undefined}
      >
        {loading ? loadingLabel : label}
      </ButtonComponent>
      <Box role="status" aria-live="polite">
        {isDisabled && !loading && disabledReason ? (
          <Typography variant="body1" color="text.secondary" sx={stylesSx}>
            {disabledReason}
          </Typography>
        ) : null}
      </Box>
    </Box>
  )
}

SubmitButtonWithStatus.propTypes = {
  ButtonComponent: PropTypes.elementType,
  label: PropTypes.string,
  loadingLabel: PropTypes.string,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
  loading: PropTypes.bool,
  buttonProps: PropTypes.object,
}
